//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AppSetPermissions from "./AppSetPermissions.vue";
import AppPermissionsItemApp from "./AppPermissionsItemApp.vue";
import { PERMISSIONS_ROLES } from "./appPermissionsRolesConst";

export default {
    name: "AppAccessPermissions",
    components: {
        AppSetPermissions,
        AppPermissionsItemApp,
        AQButton,
        AQDialog
    },
    props: {
        type: {
            type: String,
            default: ""
        },
        value: {
            type: Array,
            default: () => []
        },
        inheritedPermissions: {
            type: Array,
            default: () => []
        },
        readOnlyPermissions: {
            type: Boolean,
            default: false
        },
        hideNotifications: {
            type: Boolean,
            default: false
        },
        appIdGroup: { // applicationId if group type = aplication specific group (TPD)
            type: String,
            default: ""
        },
        fromGDM: {
            type: Boolean,
            default: false
        },
        userdata: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            openNewPermissions: false,
            inheritedAppsPermissions: [],
            directAppsPermissions: [],
            currentSelectedPerm: {},
            currentAppIndex: null,
            excludeApps: [],
            showRemoveConfirmation: false,
            valueOnLoad: true,
            dynamicPermissions: {}
        };
    },
    computed: {
        ...mapGetters("apps", ["apps"]),
        ...mapGetters("admin", ["roleList", "getPermissionsRolesGroupSelected", "getProcessDetailsAndRoles"]),
        showAddButton() {
            const showButton = this.appIdGroup ? !this.directAppsPermissions.length : true;
            return showButton && !this.readOnlyPermissions;
        },
        getInheritedDescription() {
            return this.type === "user" ? this.$t("appSetPermissions.inheritedPermDescUser") : this.$t("appSetPermissions.inheritedPermDesc");
        },
        getDirectDescription() {
            return this.type === "user" ? this.$t("appSetPermissions.directPermDescUser") : this.$t("appSetPermissions.directPermDesc");
        },
        displayDeleteMessage() {
            return this.type === "user" ? this.$t("appEditPermissions.dialogBodyUser") : this.$t("appEditPermissions.dialogBodyGroup");
        }
    },
    watch: {
        value: {
            handler(newValue) {
                if (newValue && this.valueOnLoad) {
                    this.excludeApps = [];
                    this.directAppsPermissions = this.setPermissionsData(newValue);
                }
            },
            immediate: true
        },
        inheritedPermissions: {
            handler(newValue) {
                this.inheritedAppsPermissions = this.setPermissionsData(newValue, true);
            },
            immediate: true
        },
        apps: {
            handler(newValue) {
                if (newValue && newValue.length) {
                    this.excludeApps = [];
                    this.directAppsPermissions = this.setPermissionsData(this.value);
                    this.inheritedAppsPermissions = this.setPermissionsData(this.inheritedPermissions, true);
                }
            },
            immediate: true
        }
    },
    created() {
        if (!this.apps || (Array.isArray(this.apps) && !this.apps.length)) {
            this.getAllApps();
        }
    },
    methods: {
        ...mapActions("apps", ["getAllApps"]),
        getDynamicPermissions(data) {
            if (data && data.length) {
                this.dynamicPermissions = {};
                data.forEach(({ code, name }) => {
                    this.dynamicPermissions[code] = name;
                });
            }
        },
        setPermissionsData(data, inherited) {
            const dataPermissions = [];
            data.forEach(element => {
                let selectedApp = { ...this.apps.find(app => app.id === element.targetId) };
                if (Object.keys(selectedApp).length) {
                    const permissionsType = element.roles || [];
                    selectedApp.permissions = permissionsType.map(elem => {
                        if (elem.code) {
                            elem.code = elem.code.trim();
                        }

                        return elem;
                    });
                    if (selectedApp.permissions.length) {
                        const getDynamicPermissions = this.type === "user" ? this.getProcessDetailsAndRoles : this.getPermissionsRolesGroupSelected;
                        const perspectivePermTranslate = getDynamicPermissions && getDynamicPermissions.directPermTranslation
                            ? (getDynamicPermissions.directPermTranslation[selectedApp.id] || {}) : {};
                        const allPermissionRoles = PERMISSIONS_ROLES;
                        const getTranslation = (v) => (allPermissionRoles.includes(v)
                            ? this.$t(`applicationPermissions.${v}Role`) : (perspectivePermTranslate[v] || this.dynamicPermissions[v] || v)
                        );
                        const getPermissionsCode = () => {
                            const permissionsList = [];
                            selectedApp.permissions.forEach(perm => {
                                if (perm.code === "INITIATOR" && perm.id) {
                                    permissionsList.push(perm.id);
                                } else {
                                    permissionsList.push(perm.code);
                                }
                            });
                            return permissionsList;
                        };

                        const traslatedPermissions = getPermissionsCode().map(perm => ({ name: getTranslation(perm) }));
                        selectedApp = { ...selectedApp, traslatedPermissions };
                    }

                    if (inherited) {
                        if (element.innerGrouDetails && element.innerGrouDetails.length) {
                            const groupList = [];
                            element.innerGrouDetails.forEach(group => {
                                groupList.push({
                                    name: group.groupName,
                                    groupId: group.groupId,
                                    type: "GROUP",
                                    systemType: group.systemType
                                });
                            });
                            selectedApp.groups = groupList;
                        }
                    } else {
                        this.excludeApps.push(selectedApp.id);
                    }
                    dataPermissions.push(selectedApp);
                }
            });
            return dataPermissions;
        },
        setNewPermissionsData(data) {
            let selectedApp = this.apps.find(element => element.id === data.id);
            const checkIfExist = this.directAppsPermissions.findIndex(element => element.id === data.id);
            if (selectedApp) {
                selectedApp.permissions = data.permissions;
                if (data.permissions.length) {
                    const getDynamicPermissions = this.type === "user" ? this.getProcessDetailsAndRoles : this.getPermissionsRolesGroupSelected;
                    const perspectivePermTranslate = getDynamicPermissions && getDynamicPermissions.directPermTranslation
                        ? (getDynamicPermissions.directPermTranslation[selectedApp.id] || {}) : {};
                    const allPermissionRoles = PERMISSIONS_ROLES;
                    const getTranslation = (v) => (allPermissionRoles.includes(v)
                        ? this.$t(`applicationPermissions.${v}Role`) : (perspectivePermTranslate[v] || this.dynamicPermissions[v] || v)
                    );

                    const getPermissionsCode = () => {
                        const permissionsList = [];

                        data.permissions.forEach(perm => {
                            if (perm.code === "INITIATOR" && perm.id) {
                                const roleName = `${this.$t("applicationPermissions.INITIATORTitle")} "${perm.name}"`;
                                permissionsList.push(roleName);
                            } else {
                                permissionsList.push(perm.code);
                            }
                        });
                        return permissionsList;
                    };
                    const traslatedPermissions = getPermissionsCode().map(element => ({ name: getTranslation(element) }));
                    selectedApp = { ...selectedApp, traslatedPermissions };
                }
                if (checkIfExist !== -1) {
                    this.directAppsPermissions[checkIfExist] = selectedApp;
                } else {
                    this.directAppsPermissions.push(selectedApp);
                    this.excludeApps.push(selectedApp.id);
                }
                this.currentSelectedPerm = [];
                this.valueOnLoad = false;
                this.$emit("input", this.directAppsPermissions);
                this.$root.$emit("changeValue", false);
            }
        },
        deletePermission(index) {
            this.currentAppIndex = index;
            this.showRemoveConfirmation = true;
        },
        actionRemoveApp(data, remove) {
            if (remove) {
                if (typeof this.currentAppIndex === "number") {
                    this.directAppsPermissions.splice(this.currentAppIndex, 1);
                    this.excludeApps.splice(this.currentAppIndex, 1);
                }
                this.openNewPermissions = false;
                this.valueOnLoad = false;
                this.$emit("input", this.directAppsPermissions);
                this.$root.$emit("changeValue", false);
            }
            this.currentAppIndex = null;
            this.showRemoveConfirmation = false;
        },
        openDetails(app, index) {
            if (!this.readOnlyPermissions) {
                this.openNewPermissions = true;
                this.currentSelectedPerm = { ...app, currectIndex: index };
            }
        },
        addNewPermissions() {
            const details = this.appIdGroup ? { id: this.appIdGroup } : {};
            this.currentSelectedPerm = details;
            this.openNewPermissions = true;
        }
    }
};
